"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const react_i18next_1 = require("react-i18next");
const react_slick_1 = require("react-slick");
const TicketScreenStyle_1 = require("./jss/TicketScreenStyle");
const TicketCardContent_1 = require("./TicketCardContent");
const SlicKButton = (0, core_1.styled)(core_1.Button)(({ theme }) => ({
    position: 'absolute',
    zIndex: 2,
    top: '50%',
    transform: 'translateY(-50%)',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    background: 'rgb(255 255 255 / 80%)',
    minWidth: '40px',
    padding: 0,
    left: '10px'
}));
const TicketSlider = ({ data, loading, onTicketSubmit, showSampleTicketHelpImage, successfulEntered, showConsentText, isQuickCardVisible, navigateToGames, t, classes, isRestricted, handleContactUs }) => {
    const renderSlides = () => data.map((tab) => ((0, jsx_runtime_1.jsx)(TicketCardContent_1.default, { ticketTab: tab, loading: loading, onSubmit: onTicketSubmit, showSampleTicketHelpImage: showSampleTicketHelpImage.bind(tab.tabKey), navigateToGames: navigateToGames, successfulEntered: successfulEntered, showConsentText: showConsentText, label: t(tab.tabTitle), tabLogo: tab.tabLogo, isQuickCardVisible: isQuickCardVisible, isRestricted: isRestricted, handleContactUs: handleContactUs }, tab.tabKey)));
    const PrevArrow = (props) => {
        const { onClick } = props;
        return ((0, jsx_runtime_1.jsx)(SlicKButton, Object.assign({ onClick: onClick, "aria-label": "Previous Slider" }, { children: (0, jsx_runtime_1.jsx)(icons_1.ArrowBackIosRounded, { color: 'primary', fontSize: 'small' }) })));
    };
    const NextArrow = (props) => {
        const { onClick } = props;
        return ((0, jsx_runtime_1.jsx)(SlicKButton, Object.assign({ onClick: onClick, style: {
                left: 'unset',
                right: '10px'
            }, "aria-label": "Next Slider" }, { children: (0, jsx_runtime_1.jsx)(icons_1.ArrowForwardIosRounded, { color: 'primary', fontSize: 'small' }) })));
    };
    const settings = {
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        prevArrow: (0, jsx_runtime_1.jsx)(PrevArrow, {}),
        nextArrow: (0, jsx_runtime_1.jsx)(NextArrow, {})
    };
    return data != null && data.length > 0 ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.carouselContainer }, { children: (0, jsx_runtime_1.jsx)(react_slick_1.default, Object.assign({ className: "slider" }, settings, { children: renderSlides() })) }))) : ((0, jsx_runtime_1.jsx)("div", {}));
};
exports.default = (0, core_1.withStyles)(TicketScreenStyle_1.default)((0, react_i18next_1.withTranslation)()(TicketSlider));
//# sourceMappingURL=TicketSlider.js.map